(() => {
  const initialize = (root = document) => root.querySelectorAll('[data-brand-parts]').forEach((hub) => {
    if (hub.dataset.initialized) return;
    hub.dataset.initialized = 'true';
    const form = hub.querySelector('[data-brand-parts-form]');
    const input = form.elements.q;
    const results = hub.querySelector('[data-parts-results]');
    const status = hub.querySelector('[data-parts-status]');
    const error = hub.querySelector('[data-parts-error]');
    const clear = hub.querySelector('[data-parts-clear]');
    const initialParams = new URLSearchParams(location.search);
    const preview = initialParams.get('preview_theme_id');
    const contactDialog = hub.querySelector('[data-parts-contact-dialog]');
    const shortcuts = hub.querySelector('[data-parts-model-shortcuts]');
    const shortcutList = hub.querySelector('[data-parts-model-list]');
    const entries = [...hub.querySelectorAll('[data-book-entry]')];
    const compact = (text) => text.toLocaleLowerCase().replace(/[^a-z0-9]/g, '');
    let contactTrigger;
    let controller;
    let currentQuery = '';
    let currentPreferExact = true;
    const addressKey = () => {
      const params = new URLSearchParams(location.search);
      const query = params.get('parts_q') || '';
      return JSON.stringify([location.pathname, query, Number(params.get(query ? 'parts_page' : 'page')) || 1, params.get('parts_matches') || '']);
    };
    let knownAddress = addressKey();
    function updateHelpers() {
      const entered = input.value.trim();
      const broad = new URL('/collections/parts', location.origin);
      if (entered) broad.searchParams.set('parts_q', entered);
      if (preview) broad.searchParams.set('preview_theme_id', preview);
      hub.querySelectorAll('[data-parts-all-brands]').forEach((link) => { link.href = broad.href; });
      const context = new URL(hub.dataset.hubUrl, location.origin);
      if (entered) context.searchParams.set('parts_q', entered);
      const lines = ['Hi Keast parts team,', '', 'I need help identifying a part.', '', entered ? 'I searched for: ' + entered : '', hub.dataset.brand ? 'Make: ' + hub.dataset.brand : '', '', 'Any details I have:', '', '', 'Page: ' + context.href];
      const email = 'mailto:parts@keastenterprises.com?subject=' + encodeURIComponent(hub.dataset.emailSubject) + '&body=' + encodeURIComponent(lines.join('\n'));
      hub.querySelectorAll('[data-parts-email]').forEach((link) => { link.href = email; });
      if (contactDialog) hub.querySelectorAll('[data-parts-contact]').forEach((link) => {
        link.setAttribute('role', 'button'); link.setAttribute('aria-haspopup', 'dialog'); link.setAttribute('aria-controls', contactDialog.id);
      });
      if (!shortcuts || !shortcutList) return;
      const terms = entered.toLocaleLowerCase().split(/\s+/).map(compact).filter(Boolean);
      const matches = entered.length < 2 ? [] : entries.filter((entry) => {
        const label = entry.querySelector('h3')?.textContent || '';
        const coverage = [...entry.querySelectorAll('p')].map((node) => node.textContent).join(' ');
        const text = compact(entry.dataset.bookEntry + ' ' + label + ' ' + coverage);
        return terms.every((term) => text.includes(term));
      });
      const matchesTitle = (entry) => {
        const title = compact(entry.dataset.bookEntry + ' ' + (entry.querySelector('h3')?.textContent || ''));
        return terms.every((term) => title.includes(term));
      };
      matches.sort((a, b) => Number(matchesTitle(b)) - Number(matchesTitle(a)));
      shortcutList.replaceChildren();
      for (const entry of matches.slice(0, 4)) {
        const item = document.createElement('li');
        const heading = document.createElement('h3');
        heading.textContent = entry.dataset.bookEntry + ' · ' + entry.querySelector('h3').textContent;
        const qualifications = document.createElement('div');
        qualifications.className = 'keast-parts__shortcut-qualifiers';
        const qualificationText = [];
        for (const original of entry.querySelectorAll('p')) {
          const paragraph = original.cloneNode(true);
          paragraph.removeAttribute('id'); paragraph.removeAttribute('aria-labelledby');
          paragraph.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          qualifications.append(paragraph);
          qualificationText.push(original.textContent.trim());
        }
        const qualifiedName = [heading.textContent, ...qualificationText].filter(Boolean).join(' — ');
        const actions = document.createElement('div'); actions.className = 'keast-parts__shortcut-actions';
        for (const original of entry.querySelectorAll('.keast-books__links a')) {
          const link = original.cloneNode(true);
          link.removeAttribute('id'); link.removeAttribute('aria-labelledby');
          link.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          link.setAttribute('aria-label', original.textContent.trim() + ': ' + qualifiedName);
          if (new URL(original.href, location.origin).pathname.startsWith('/collections/') || new URL(original.href, location.origin).pathname.startsWith('/products/')) link.dataset.shortcutParts = '';
          actions.append(link);
        }
        item.append(heading); if (qualifications.childElementCount) item.append(qualifications); item.append(actions); shortcutList.append(item);
      }
      shortcuts.hidden = matches.length === 0;
    }
    input.value = initialParams.get('parts_q') || '';
    input.addEventListener('input', updateHelpers);
    input.addEventListener('search', updateHelpers);
    updateHelpers();
    if (contactDialog && typeof contactDialog.showModal === 'function') {
      hub.addEventListener('click', (event) => {
        const link = event.target.closest('[data-parts-contact]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); contactTrigger = link; contactDialog.showModal();
      });
      hub.addEventListener('keydown', (event) => {
        const link = event.target.closest('[data-parts-contact]');
        if (link && event.key === ' ') { event.preventDefault(); link.click(); }
      });
      contactDialog.querySelector('[data-parts-contact-close]').addEventListener('click', () => contactDialog.close());
      contactDialog.addEventListener('click', (event) => {
        if (event.target !== contactDialog) return;
        const box = contactDialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) contactDialog.close();
      });
      contactDialog.addEventListener('close', () => contactTrigger?.focus({preventScroll:true}));
    }
    const brandNavigation = hub.querySelector('[data-parts-brands]');
    if (brandNavigation) {
      const filter = brandNavigation.querySelector('[data-brand-filter]');
      const items = [...brandNavigation.querySelectorAll('[data-brand-item]')];
      items.sort((a, b) => a.dataset.brandName.localeCompare(b.dataset.brandName, undefined, {sensitivity:'base',ignorePunctuation:true,numeric:true}));
      brandNavigation.querySelector('ul').append(...items);
      const empty = brandNavigation.querySelector('[data-brand-empty]');
      const announcement = brandNavigation.querySelector('[data-brand-filter-status]');
      brandNavigation.querySelector('[data-brand-filter-controls]').hidden = false;
      const filterBrands = () => {
        const term = compact(filter.value.trim()); let visible = 0;
        items.forEach((item) => { item.hidden = !compact(item.dataset.brandName).includes(term); if (!item.hidden) visible++; });
        empty.hidden = visible !== 0;
        announcement.textContent = term ? visible + ' matching brands' : '';
      };
      filter.addEventListener('input', filterBrands); filter.addEventListener('search', filterBrands);
      brandNavigation.querySelector('[data-brand-filter-clear]').addEventListener('click', () => { filter.value = ''; filterBrands(); filter.focus(); });
    }
    const searchUrl = (query, pageNumber = 1) => {
      const url = new URL(form.action, location.origin);
      for (const [key, value] of new FormData(form)) url.searchParams.set(key, value);
      url.searchParams.set('q', KeastSearch.build(query, 'parts', hub.dataset.brand));
      if (pageNumber > 1) url.searchParams.set('page', pageNumber);
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url;
    };
    const browseUrl = (pageNumber = 1) => {
      const url = new URL(hub.dataset.hubUrl, location.origin);
      if (pageNumber > 1) url.searchParams.set('page', pageNumber);
      if (preview) url.searchParams.set('preview_theme_id', preview);
      if (initialParams.has('view')) url.searchParams.set('view', initialParams.get('view'));
      return url;
    };
    function verified(fragment) {
      if (!fragment) return false;
      const rows = [...fragment.querySelectorAll('[data-part-vendor]')];
      const empty = fragment.dataset.partsEmpty === 'true' && rows.length === 0;
      return (empty || (fragment.dataset.partsValid === 'true' && fragment.dataset.partsBrand === hub.dataset.brand)) && rows.every((row) => (!hub.dataset.brand || row.dataset.partVendor === hub.dataset.brand) && KeastSearch.isParts(row.dataset.partType));
    }
    async function retrieve(url, signal) {
      const response = await fetch(url, {signal,credentials:'same-origin'});
      if (!response.ok) {
        const failure = new Error('Parts request failed'); failure.status = response.status; throw failure;
      }
      return new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-parts-fragment]');
    }
    async function load(query, pageNumber = 1, push = true, focus = true, preferExact = true) {
      controller?.abort(); controller = new AbortController();
      const active = controller;
      const timeout = setTimeout(() => active.abort(), 15000);
      const request = query ? searchUrl(query, pageNumber) : browseUrl(pageNumber);
      const fallback = new URL(request);
      request.searchParams.set('section_id', query ? 'keast-brand-parts-results' : hub.dataset.hubSection);
      results.hidden = false; results.setAttribute('aria-busy', 'true'); error.hidden = true; status.textContent = hub.dataset.loading;
      try {
        let fragment;
        let exact = false;
        if (query.length >= 3 && pageNumber === 1 && preferExact && /\d/.test(query) && /^[a-z0-9][a-z0-9._/-]*$/i.test(query)) {
          const exactRequest = new URL(request);
          const brand = hub.dataset.brand ? ' AND vendor:' + JSON.stringify(hub.dataset.brand) : '';
          exactRequest.searchParams.set('q', 'product_type:Parts' + brand + ' AND (variants.sku:' + JSON.stringify(query) + ')');
          try {
            const found = await retrieve(exactRequest, active.signal);
            const rows = verified(found) ? [...found.querySelectorAll('[data-part-vendor]')].filter((row) => row.querySelector('.keast-parts__sku')?.textContent.trim().toLocaleLowerCase() === query.toLocaleLowerCase()) : [];
            if (rows.length) {
              fragment = found; exact = true;
              fragment.querySelector('.keast-parts__list').replaceChildren(...rows);
              fragment.querySelectorAll('.keast-parts__pagination').forEach((node) => node.remove());
              fragment.querySelector('[data-results-heading]').textContent = hub.dataset.exactLabel;
              fragment.querySelector('.keast-parts__query').textContent = query;
              const more = document.createElement('a'); more.href = fallback.href; more.className = 'keast-parts__related'; more.dataset.partsRelated = ''; more.textContent = hub.dataset.relatedLabel;
              fragment.append(more);
            }
          } catch (exception) { if (active.signal.aborted || exception.status || exception instanceof TypeError) throw exception; }
        }
        if (!fragment) fragment = await retrieve(request, active.signal);
        if (!exact && query && fragment?.dataset.partsEmpty === 'true') {
          const nativeRequest = new URL(request); nativeRequest.searchParams.set('q', query);
          const native = await retrieve(nativeRequest, active.signal);
          if (verified(native)) fragment = native;
        }
        if (!verified(fragment)) throw new Error('Parts scope not verified');
        if (active !== controller) return;
        if (query && !exact) {
          const list = fragment.querySelector('.keast-parts__list');
          const rows = [...(list?.children || [])];
          const matches = rows.filter((row) => row.querySelector('.keast-parts__sku')?.textContent.trim().toLocaleLowerCase() === query.toLocaleLowerCase());
          if (matches.length) list.prepend(...matches);
        }
        results.replaceChildren(fragment); currentQuery = query; currentPreferExact = preferExact; input.value = query; clear.hidden = !query;
        if (push) {
          const address = browseUrl(query ? 1 : pageNumber);
          if (query) {
            address.searchParams.set('parts_q', query);
            if (pageNumber > 1) address.searchParams.set('parts_page', pageNumber);
            if (!preferExact) address.searchParams.set('parts_matches', 'all');
          }
          history.pushState({}, '', address); knownAddress = addressKey();
        }
        updateHelpers();
        status.textContent = results.querySelector('[data-results-heading]')?.textContent || hub.dataset.loaded;
        if (focus) results.querySelector('[data-results-heading]')?.focus({preventScroll:false});
      } catch (exception) {
        if (active !== controller) return;
        results.hidden = true; error.hidden = false; hub.querySelector('[data-parts-fallback]').href = fallback.href; status.textContent = '';
      } finally { clearTimeout(timeout); if (active === controller) results.setAttribute('aria-busy', 'false'); }
    }
    form.addEventListener('submit', (event) => { event.preventDefault(); load(KeastSearch.normalize(KeastSearch.decode(input.value).terms)); });
    clear.addEventListener('click', (event) => { if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return; event.preventDefault(); load(''); });
    results.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const change = event.target.closest('[data-parts-change-search]');
      if (change) { event.preventDefault(); input.focus(); input.select(); return; }
      const related = event.target.closest('[data-parts-related]');
      if (related) { event.preventDefault(); load(currentQuery, 1, true, true, false); return; }
      const link = event.target.closest('a[data-part-page]');
      if (!link) return;
      event.preventDefault(); load(currentQuery, Number(new URL(link.href).searchParams.get('page')) || 1, true, true, currentPreferExact);
    });
    const restore = (force = false) => {
      const nextAddress = addressKey(); if (!force && nextAddress === knownAddress) return;
      knownAddress = nextAddress;
      const params = new URLSearchParams(location.search); const query = params.get('parts_q') || '';
      load(query, Number(params.get(query ? 'parts_page' : 'page')) || 1, false, false, params.get('parts_matches') !== 'all');
    };
    window.addEventListener('popstate', () => restore());
    if (initialParams.has('parts_q')) restore(true);
  });
  const start = () => {
    if (window.KeastSearch) initialize();
    else document.addEventListener('keast:search-ready', () => initialize(), {once:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
